import { Flex, Heading } from '@chakra-ui/react'
import { NavLink } from 'react-router-dom'
import { ParentMenuProps } from '../../../types/sidebar-v2.type'
import useSidebarV2 from '../useSidebarV2'
import NewFeatureTag from './NewFeatureTag'

interface SubMenuChildProps {
  parentMenu: ParentMenuProps
  removeMarginLeft?: boolean
  removePaddingTop?: boolean
}

export default function SubMenuChild(props: SubMenuChildProps) {
  const {
    parentMenu,
    removeMarginLeft,
    removePaddingTop,
  } = props

  const { textColor } = useSidebarV2()

  return (
    <Flex
      direction='column'
      gap='8px'
      paddingTop={removePaddingTop ? '0px' : '4px'}
    >
      {parentMenu.subMenus.map((subMenu, subMenuIndex) => {
        return (
          <NavLink
            key={subMenuIndex}
            to={subMenu.href}
            end
          >
            {({ isActive }) => (
              <Flex
                padding='4px'
                alignItems='center'
                gap='8px'
                borderRadius='8px'
                width='100%'
              >
                <Flex
                  width='2px'
                  height='20px'
                  borderRadius='1px'
                  backgroundColor={textColor}
                  marginLeft={removeMarginLeft ? '0px' : '18px'}
                  visibility={isActive ? 'visible' : 'hidden'}
                />
                <Heading size='chakra_label_large' color={textColor}>{subMenu.label}</Heading>
                {subMenu.isNew
                  ? <NewFeatureTag />
                  : null
                }
              </Flex>
            )}
          </NavLink>
        )
      })}
    </Flex>
  )
}
